import {
  takeLatest,
  put,
  call,
  select,
  take,
  cancel,
} from 'redux-saga/effects';

import * as inspectPatient from '../requests/inspect-patient-form';
import * as inspectReq from '../requests/inspection-req';
import deepTrim from '../../../utils/converters/deepTrim';
import { APPOINTMENT_INSPECTION, INLINE_TYPES } from '../../../constants';

import {
  selectProgressCareUser,
  selectProgressVisitTypeCode,
} from '../selectors';
import {
  APPOINTMENT_PROGRESS_TYPES,
  appointmentProgressActions,
} from '../progress-types';
import { handleShowEmergencyContactStep } from './inspectAll-saga';

const { PROFILE, LOCAL_PROFILE } = APPOINTMENT_INSPECTION;

function* validatePatientProfileInspection({ payload: profile }) {
  const { id: userId } = yield select(selectProgressCareUser);
  const visitTypeCode = yield select(selectProgressVisitTypeCode);

  const inInlineVisitType = INLINE_TYPES.includes(visitTypeCode);

  const inspectionFor = inInlineVisitType ? LOCAL_PROFILE : PROFILE;

  const payload = { profile };

  yield put(
    inspectPatient.actions.send(deepTrim({ userId, inspectionFor, payload })),
  );

  const {
    payload: [inspection],
  } = yield take(inspectPatient.consts.SUCCEED);

  yield put(inspectReq.actions.setEntity({ [inspectionFor]: inspection }));
  yield put(appointmentProgressActions.setPatientInfo(profile));

  if (inspectionFor === PROFILE && inspection.fieldList.length > 0) {
    yield cancel();
  }

  yield call(handleShowEmergencyContactStep);
}

export default function* inspectPatientSaga() {
  yield takeLatest(
    APPOINTMENT_PROGRESS_TYPES.INSPECT_PATIENT,
    validatePatientProfileInspection,
  );
}



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/sagas/inspect-patient-saga.js